import { useTheme } from 'next-themes';
import { getOptimalTextColor } from './Common/Edge';

export function CIcon(props: {
  size: number;
  name: string;
  rotate?: number;
  color?: string;
  auto?: boolean;
  baseColor?: string;
  className?: string;
}) {
  const actualColor =
    props.baseColor && props.baseColor.length > 0
      ? getOptimalTextColor(props.baseColor)
      : props.color;

  if (actualColor)
    return (
      <div
        className={`mask-no-repeat mask-center ${props.auto ? 'mask-auto' : 'mask-cover'} ${
          props.className || ''
        }`}
        style={{
          width: props.size,
          height: props.size,
          ...(props.rotate !== undefined ? { rotate: `${props.rotate}deg` } : {}),
          backgroundColor: actualColor,
          maskImage: `url(/images/ic_${props.name}.svg)`,
          WebkitMaskImage: `url(/images/ic_${props.name}.svg)`,
        }}
      ></div>
    );
  else
    return (
      <div
        className={`bg-no-repeat bg-center ${props.auto ? 'bg-auto' : 'bg-cover'} ${
          props.className || ''
        }`}
        style={{
          width: props.size,
          height: props.size,
          backgroundImage: `url(/images/ic_${props.name}.svg)`,
          ...(props.rotate !== undefined ? { rotate: `${props.rotate}deg` } : {}),
        }}
      ></div>
    );
}

export function CIconTest() {
  const { resolvedTheme } = useTheme();
  const icons = [
    '3d_interactive_shot_1',
    '3d_interactive_shot',
    '3D_perspective',
    '3D_surface',
    '3D_view_b',
    '3D_view_l',
    '3D_view_r',
    '3D_view_t',
    '3D_wireframe',
    '3d',
    'appicon_dark',
    'appicon_gray',
    'appicon',
    'arrow_r',
    'arrow',
    'artifact',
    'brush_toolbar',
    'brush',
    'check',
    'check2',
    'collpase',
    'color',
    'copy',
    'curve',
    'done',
    'edit',
    'effect',
    'ellipse_select',
    'eraser',
    'expand',
    'export',
    'file',
    'free_lasso',
    'gen3d',
    'generate_w',
    'generate',
    'grid',
    'history',
    'image',
    'import',
    'insert',
    'invisible',
    'lasso',
    'light',
    'line',
    'link',
    'lock',
    'mic',
    'minus',
    'more',
    'move',
    'next',
    'nx',
    'palette_on',
    'pause',
    'people',
    'play',
    'play2',
    'plus',
    'poly_lasso',
    'ratio_1_1',
    'ratio_3_4',
    'ratio_4_3',
    'ratio_9_16',
    'ratio_16_9',
    'ratio_free',
    'record_done',
    'rectangle_select',
    'rectangle',
    'redo',
    'repeat',
    'send',
    'shape',
    'share',
    'spoid',
    'stop',
    'subtract',
    'symmetry',
    'text',
    'thinking',
    'thumb_edit',
    'tooltip',
    'trash_all',
    'trash',
    'undo',
    'unlock',
    'upload',
    'video_crop',
    'video_trim',
    'video',
    'visible',
    'web',
  ];
  return (
    <>
      <h3 className="dark:text-white mt-3">CIcon</h3>
      <div className="flex gap-[10px]">
        <CIcon size={28} name="arrow" color="red" />
        <CIcon size={28} name="arrow" rotate={180} color="blue" />
      </div>
      <div className="flex gap-[5px] flex-wrap">
        {icons.map((icon, i) => (
          <div key={i} className="flex flex-col items-center">
            <CIcon
              size={28}
              name={icon}
              color={icon.includes('appicon') ? '' : resolvedTheme === 'dark' ? 'white' : '#404040'}
            />
            <span className="text-[#404040] dark:text-white text-[8px]">{icon}</span>
          </div>
        ))}
      </div>
    </>
  );
}
